import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageKO() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: AI 관계 분석 | 유해한 패턴 및 가스라이팅 감지" description="전 애인이 문제인지 확인하세요. ToxicDetector의 AI에 채팅을 업로드하여 조종, 가스라이팅 및 위험 신호를 즉각적이고 기밀로 분석합니다. 오늘 무료 스캔을 시작하세요." keywords="AI 관계 분석, 유해한 패턴 감지, 가스라이팅 감지기, 유해한 전 애인, 조종 확인, 관계 독성, AI 텍스트 스캐너" canonical="https://toxicdetector.com/ko" language="ko" alternateUrls={alternateUrls} data-id="element-8331" data-mp="35l3v3wgcb33a" />
      <GoogleTranslateWidget data-id="element-8332" data-mp="1jinb21x3xcr9" />
      <PromoBanner data-id="element-8333" data-mp="1jgsvl34lucuk" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-8334" data-mp="1ejkel5v70euw">
        <Header data-id="element-8335" data-mp="qtzugjnazbk1" />
        <main data-id="element-8336" data-mp="qtq06jv86i8j">
          <HeroSection h1Override={<>
                당신의 뇌는{' '}
                <span className="relative inline-block" data-id="element-8338" data-mp="mu7gfrf54d7a">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-8339" data-mp="10k18eilxzdl8">
                    거짓말
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-8340" data-mp="vrhwrr6tesj2" />
                </span>{' '}
                을 하고 있습니다.
                <br data-id="element-8341" data-mp="34nduypnc17p" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-8342" data-mp="332pjqtxdeia">
                  우리 AI는 아닙니다.
                </span>
              </>} data-id="element-8337" data-mp="qvaymkknulbo" />
          <TrustSection data-id="element-8343" data-mp="2jl3jkg752uq5" />
          <FeaturesSection data-id="element-8344" data-mp="25rubqjyuah9q" />
          <GuaranteesSection data-id="element-8345" data-mp="25snaoyrk42hb" />
          <ToolsSection data-id="element-8346" data-mp="25tf7gcww4696" />
          <ComparisonSection data-id="element-8347" data-mp="2aqoslgd8xvr7" />
          <PricingSection data-id="element-8348" data-mp="2apvv7606gilq" />
          <FAQSection data-id="element-8349" data-mp="2ar6xf1dz5iaq" />
          <CTASection data-id="element-8350" data-mp="2aoktdbqalkx9" />
        </main>
        <Footer data-id="element-8351" data-mp="2yfq81nkhy75z" />
      </div>
    </>;
}